import React from "react";
import { onlyNumericInput } from "@/utils";

export const FormMechanic = ({ formData, handleChange, setFormData }) => {
    return (
        <>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>협력 보험사명</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="member.mechanicInfo.insuranceCorpName"
                            placeholder="협력 보험사명"
                            value={formData?.member?.mechanicInfo?.insuranceCorpName}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>공업사명</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="member.mechanicInfo.mechanicName"
                            placeholder="공업사명"
                            value={formData?.member?.mechanicInfo?.mechanicName}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>공업사 연락처</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="member.mechanicInfo.mechanicPhone"
                            placeholder="공업사 연락처"
                            value={formData?.member?.mechanicInfo?.mechanicPhone}
                            onChange={handleChange}
                            onInput={onlyNumericInput}
                            maxLength={11}
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="2/3">
                <div className="row-head">
                    <span>공업사 주소</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="member.mechanicInfo.mechanicAddress"
                            placeholder="공업사 주소"
                            value={formData?.member?.mechanicInfo?.mechanicAddress}
                            onChange={handleChange}
                            readOnly
                            onClick={() => {
                                setFormData((prev) => ({
                                    ...prev,
                                    member: {
                                        ...prev.member,
                                        mechanicInfo: {
                                            ...prev.member.mechanicInfo,
                                            addressPopupStatus: true,
                                            addressPopupTarget: "MECHANIC_PARTNER",
                                        },
                                    },
                                }));
                            }}
                        />
                    </div>
                    <div className="form-element_button">
                        <button
                            type="button"
                            className="btn-form_element btn-outline"
                            onClick={() => {
                                setFormData((prev) => ({
                                    ...prev,
                                    member: {
                                        ...prev.member,
                                        mechanicInfo: {
                                            ...prev.member.mechanicInfo,
                                            addressPopupStatus: true,
                                            addressPopupTarget: "MECHANIC_PARTNER",
                                        },
                                    },
                                }));
                            }}
                        >
                            검색
                        </button>
                    </div>
                    <div className="form-element">
                        <input
                            type="text"
                            name="member.mechanicInfo.mechanicAddressDetail"
                            placeholder="상세주소"
                            value={formData?.member?.mechanicInfo?.mechanicAddressDetail}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>사업자등록번호</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="member.mechanicInfo.bizNumber"
                            placeholder="사업자등록번호"
                            value={formData?.member?.mechanicInfo?.bizNumber}
                            onChange={handleChange}
                            onInput={onlyNumericInput}
                            maxLength={10}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
